"use strict";

exports.__esModule = true;
exports.Event = void 0;
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/
/** Stores the current pose values for an {@link Event}.
 *
 * See Timeline {@link Timeline#apply()},
 * AnimationStateListener {@link AnimationStateListener#event()}, and
 * [Events](http://esotericsoftware.com/spine-events) in the Spine User Guide. */
var Event = function Event(time, data) {
  this.data = null;
  this.intValue = 0;
  this.floatValue = 0;
  this.stringValue = null;
  this.time = 0;
  this.volume = 0;
  this.balance = 0;
  if (!data) throw new Error("data cannot be null.");
  this.time = time;
  this.data = data;
};
exports.Event = Event;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFdmVudCIsInRpbWUiLCJkYXRhIiwiaW50VmFsdWUiLCJmbG9hdFZhbHVlIiwic3RyaW5nVmFsdWUiLCJ2b2x1bWUiLCJiYWxhbmNlIiwiRXJyb3IiLCJleHBvcnRzIl0sInNvdXJjZXMiOlsiLi4vc3JjL0V2ZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOzs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUErQkE7Ozs7O0FBQUEsSUFLYUEsS0FBSyxHQVNqQixTQUFBQSxNQUFhQyxJQUFZLEVBQUVDLElBQWU7RUFSMUMsS0FBQUEsSUFBSSxHQUFjLElBQUk7RUFDdEIsS0FBQUMsUUFBUSxHQUFXLENBQUM7RUFDcEIsS0FBQUMsVUFBVSxHQUFXLENBQUM7RUFDdEIsS0FBQUMsV0FBVyxHQUFXLElBQUk7RUFDMUIsS0FBQUosSUFBSSxHQUFXLENBQUM7RUFDaEIsS0FBQUssTUFBTSxHQUFXLENBQUM7RUFDbEIsS0FBQUMsT0FBTyxHQUFXLENBQUM7RUFHbEIsSUFBSSxDQUFDTCxJQUFJLEVBQUUsTUFBTSxJQUFJTSxLQUFLLENBQUMsc0JBQXNCLENBQUM7RUFDbEQsSUFBSSxDQUFDUCxJQUFJLEdBQUdBLElBQUk7RUFDaEIsSUFBSSxDQUFDQyxJQUFJLEdBQUdBLElBQUk7QUFDakIsQ0FBQztBQUFBTyxPQUFBLENBQUFULEtBQUEsR0FBQUEsS0FBQSJ9